module.exports = __webpack_public_path__ + "img/scene5-15.a22b66e6.png";